module.exports = __webpack_public_path__ + "d4afcc1f607714011dae4b52a8fcebad.svg";